import { render, staticRenderFns } from "./PurchaseSumUp.vue?vue&type=template&id=dfb22744&scoped=true&"
import script from "./PurchaseSumUp.vue?vue&type=script&lang=js&"
export * from "./PurchaseSumUp.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSumUp.vue?vue&type=style&index=0&id=dfb22744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb22744",
  null
  
)

export default component.exports